/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"

import Header from "components/Header"
import Footer from "components/Footer"

import "./NotFound.sass"

const NotFound = () => {
  return (
    <>
      <div id="header-root" className="isDetail">
        <Header isSlim isDetail />
      </div>

      <div className="NotFound">
        <div className="not-found-content row">
          <div className="description full">
            <h1>Zakaj ni zadetka?</h1>

            <p>
              Avtolog črpa podatke iz registra motornih vozil iz baze tehničnih
              pregledov.
            </p>

            <p>Nekateri izmed vzrokov so:</p>
            <ul>
              <li>
                Vozilo ni bilo registrirano v Republiki Sloveniji oz. VIN
                številka ne obstaja,
              </li>
              <li>
                Vozilo mlajše od štirih let in še ni opravljalo tehničnega
                pregleda,
              </li>
              <li>Vozilo je staro štiri leta in podatki še niso na voljo,</li>
              <li>
                Vozilo je starejše od štirih let in je bilo v lanskem letu
                uvoženo.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default NotFound
